// import React, { FC, useState, useEffect } from 'react'
// import { KTCard } from '../../../../../../_metronic/helpers'
// import { Link } from 'react-router-dom'

// interface ProductionListProps {
//     processName: string
//     processId: string
// }

// interface AuthData {
//     data: {
//         token: string
//         franchiseeid: string
//         pickuppointid: string
//     }
// }

// const SearchIcon = () => (
//     <svg
//         width='16'
//         height='16'
//         viewBox='0 0 24 24'
//         fill='none'
//         stroke='currentColor'
//         strokeWidth='2'
//         strokeLinecap='round'
//         strokeLinejoin='round'
//         style={{
//             position: 'absolute',
//             left: '10px',
//             top: '50%',
//             transform: 'translateY(-50%)',
//             color: '#6B7280',
//         }}
//     >
//         <circle cx='11' cy='11' r='8' />
//         <line x1='21' y1='21' x2='16.65' y2='16.65' />
//     </svg>
// )

// const ProductionList: FC<ProductionListProps> = ({
//     processName,
//     processId
// }) => {
//     const [searchQuery, setSearchQuery] = useState('')
//     const [productions, setProductions] = useState([])

//     const handleSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
//         const query = e.target.value.toLowerCase()
//         setSearchQuery(query)
//     }

//     useEffect(() => {
//         const fetchProductions = async () => {
//             try {
//                 const authData = localStorage.getItem('kt-auth-react-v')

//                 if (!authData) {
//                     throw new Error('No authentication token found')
//                 }

//                 const parsedAuthData: AuthData = JSON.parse(authData)
//                 const { token, franchiseeid, pickuppointid } = parsedAuthData.data

//                 const url = `${process.env.REACT_APP_BASE_API_URL}productions?page=0&size=50&status=WIP&processId=${processId}`

//                 const response = await fetch(url, {
//                     method: 'GET',
//                     headers: {
//                         'Content-Type': 'application/json',
//                         'Authorization': `Bearer ${token}`,
//                         'franchiseeid': franchiseeid,
//                         'pickuppointid': pickuppointid,
//                     },
//                 })

//                 if (!response.ok) {
//                     throw new Error(`HTTP error! status: ${response.status}`)
//                 }

//                 const data = await response.json()
//                 setProductions(data.data || [])

//             } catch (err) {
//                 console.error('Error fetching productions:', err)
//             }
//         }

//         fetchProductions()
//     }, [processId])

//     return (
//         <KTCard>
//             <div style={{
//                 display: "flex",
//                 justifyContent: "space-between",
//                 alignItems: "center",
//                 padding: "10px 30px"
//             }}>
//                 <div style={{
//                     position: 'relative',
//                     width: '300px',
//                 }}>
//                     <SearchIcon />
//                     <input
//                         type='text'
//                         placeholder='Search productions...'
//                         value={searchQuery}
//                         onChange={handleSearch}
//                         style={{
//                             width: '100%',
//                             height: '40px',
//                             padding: '8px 8px 8px 35px',
//                             fontSize: '14px',
//                             border: '1px solid #E5E7EB',
//                             borderRadius: '6px',
//                             outline: 'none',
//                             backgroundColor: 'white',
//                             transition: 'border-color 0.2s ease',
//                         }}
//                         onFocus={(e) => (e.target.style.borderColor = '#3B82F6')}
//                         onBlur={(e) => (e.target.style.borderColor = '#E5E7EB')}
//                     />
//                 </div>
//             </div>

//             <div style={{ marginLeft: "25px", marginRight: "25px" }}>
//                 <div className="table-responsive">
//                     <table
//                         id="kt_table_users"
//                         className="table align-middle table-row-dashed fs-6 gy-5 dataTable no-footer"
//                         style={{ width: '100%', borderCollapse: 'collapse' }}
//                     >
//                         <thead>
//                             <tr style={{
//                                 backgroundColor: '#333333',
//                                 color: 'white',
//                                 fontFamily: 'Inter, Arial, sans-serif',
//                                 fontSize: '12.32px',
//                                 fontWeight: '600',
//                                 textTransform: 'uppercase',
//                             }}>
//                                 <th style={{
//                                     padding: '15px 15px 15px 0',
//                                     textAlign: 'left',
//                                     borderBottom: '1px dotted #dee2e6',
//                                 }}>
//                                     S.N
//                                 </th>
//                                 <th style={{ padding: '15px', textAlign: 'left', borderBottom: '1px dotted #dee2e6' }}>PRODUCTION ID</th>
//                                 <th style={{ padding: '15px', textAlign: 'left', borderBottom: '1px dotted #dee2e6' }}>DATE & TIME</th>
//                                 <th style={{ padding: '15px', textAlign: 'left', borderBottom: '1px dotted #dee2e6' }}>CATEGORY</th>
//                                 <th style={{ padding: '15px', textAlign: 'left', borderBottom: '1px dotted #dee2e6' }}>ITEM</th>
//                                 <th style={{ padding: '15px', textAlign: 'left', borderBottom: '1px dotted #dee2e6' }}>WEIGHT</th>
//                                 <th style={{ padding: '15px', textAlign: 'left', borderBottom: '1px dotted #dee2e6' }}>BAG NO</th>
//                                 <th style={{ padding: '15px', textAlign: 'left', borderBottom: '1px dotted #dee2e6' }}>BATCH TAG</th>
//                                 <th style={{ padding: '15px', textAlign: 'left', borderBottom: '1px dotted #dee2e6' }}>PRINT TAG</th>
//                             </tr>
//                         </thead>
//                         <tbody className="text-black">
//                             {productions && productions.length > 0 ? (
//                                 productions.map((item: any, index: number) => (
//                                     <tr key={item.id || index} style={{ backgroundColor: 'white' }}>
//                                         <td style={{ padding: '20px 12px', borderBottom: '1px dotted #dee2e6' }}>{index + 1}</td>
//                                         <td style={{ padding: '20px 12px', borderBottom: '1px dotted #dee2e6' }}>
//                                             {item.productionId}
//                                         </td>
//                                         <td style={{ padding: '20px 12px', fontWeight: '500', borderBottom: '1px dotted #dee2e6' }}>
//                                             {new Date(parseInt(item.createdAt)).toLocaleDateString('en-GB', {
//                                                 day: '2-digit',
//                                                 month: '2-digit',
//                                                 year: 'numeric'
//                                             })}
//                                         </td>
//                                         <td style={{ padding: '20px 12px', borderBottom: '1px dotted #dee2e6' }}>
//                                             {item?.productionItemDetails?.[0]?.categoryName}
//                                         </td>
//                                         <td style={{ padding: '20px 12px', borderBottom: '1px dotted #dee2e6' }}>
//                                             {item?.productionItemDetails?.[0]?.itemName}
//                                         </td>
//                                         <td style={{ padding: '20px 12px', borderBottom: '1px dotted #dee2e6' }}>
//                                             {parseFloat(item.remainingInputQuantity).toFixed(2)}
//                                         </td>
//                                         <td style={{ padding: '20px 12px', borderBottom: '1px dotted #dee2e6' }}>

//                                         </td>
//                                         <td style={{ padding: '20px 12px', borderBottom: '1px dotted #dee2e6' }}></td>

//                                         <td style={{ padding: '20px 12px', borderBottom: '1px dotted #dee2e6' }}>
//                                             <Link
//                                                 to={`print-tag/${item.id}`}
//                                                 state={{ productionData: item }} // Pass the entire item object
//                                                 style={{
//                                                     color: 'black',
//                                                     textDecoration: 'none',
//                                                     fontWeight: '500'
//                                                 }}
//                                             >
//                                                 Print Tags
//                                             </Link>
//                                         </td>
//                                     </tr>
//                                 ))
//                             ) : (
//                                 <tr>
//                                     <td colSpan={8} className="text-center" style={{ padding: '20px 12px', color: "gray" }}>
//                                         No matching records found
//                                     </td>
//                                 </tr>
//                             )}
//                         </tbody>
//                     </table>
//                 </div>
//             </div>
//         </KTCard>
//     )
// }

// interface ProductionWrapperProps {
//     processName: string
//     processId: string
// }

// const ProductionWrapper: FC<ProductionWrapperProps> = (props) => {
//     return <ProductionList {...props} />
// }

// export { ProductionWrapper }



import React, { FC, useState, useEffect } from 'react'
import { KTCard } from '../../../../../../_metronic/helpers'
import { Link } from 'react-router-dom'

interface ProductionListProps {
    processName: string
    processId: string
}

interface AuthData {
    data: {
        token: string
        franchiseeid: string
        pickuppointid: string
    }
}

const SearchIcon = () => (
    <svg
        width='16'
        height='16'
        viewBox='0 0 24 24'
        fill='none'
        stroke='currentColor'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
        style={{
            position: 'absolute',
            left: '10px',
            top: '50%',
            transform: 'translateY(-50%)',
            color: '#6B7280',
        }}
    >
        <circle cx='11' cy='11' r='8' />
        <line x1='21' y1='21' x2='16.65' y2='16.65' />
    </svg>
)

const ProductionList: FC<ProductionListProps> = ({ processName, processId }) => {
    const [searchQuery, setSearchQuery] = useState('')
    const [productions, setProductions] = useState([])
    const [loading, setLoading] = useState(true)

    const handleSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
        const query = e.target.value.toLowerCase()
        setSearchQuery(query)
    }

    useEffect(() => {
        const fetchProductions = async () => {
            try {
                const authData = localStorage.getItem('kt-auth-react-v')
                if (!authData) {
                    throw new Error('No authentication token found')
                }
                const parsedAuthData: AuthData = JSON.parse(authData)
                const { token, franchiseeid, pickuppointid } = parsedAuthData.data
                // const url = `${process.env.REACT_APP_BASE_API_URL}productions?page=0&size=50&status=WIP&processId=${processId}`
                const url = `${process.env.REACT_APP_BASE_API_URL}productions?page=0&size=50&status=COMPLETED&processId=${processId}`
                const response = await fetch(url, {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${token}`,
                        'franchiseeid': franchiseeid,
                        'pickuppointid': pickuppointid,
                    },
                })

                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`)
                }

                const data = await response.json()
                setProductions(data.data || [])

            } catch (err) {
                console.error('Error fetching productions:', err)
            } finally {
                setLoading(false)
            }
        }

        fetchProductions()
    }, [processId])

    return (
        <KTCard>
            <div style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                padding: "10px 30px"
            }}>
                <div style={{
                    position: 'relative',
                    width: '300px',
                }}>
                    <SearchIcon />
                    <input
                        type='text'
                        placeholder='Search productions...'
                        value={searchQuery}
                        onChange={handleSearch}
                        style={{
                            width: '100%',
                            height: '40px',
                            padding: '8px 8px 8px 35px',
                            fontSize: '14px',
                            border: '1px solid #E5E7EB',
                            borderRadius: '6px',
                            outline: 'none',
                            backgroundColor: 'white',
                            transition: 'border-color 0.2s ease',
                        }}
                        onFocus={(e) => (e.target.style.borderColor = '#3B82F6')}
                        onBlur={(e) => (e.target.style.borderColor = '#E5E7EB')}
                    />
                </div>
            </div>

            <div style={{ marginLeft: "25px", marginRight: "25px" }}>
                <div className="table-responsive">
                    <table
                        id="kt_table_users"
                        className="table align-middle table-row-dashed fs-6 gy-5 dataTable no-footer"
                        style={{ width: '100%', borderCollapse: 'collapse' }}
                    >
                        <thead>
                            <tr style={{
                                backgroundColor: '#333333',
                                color: 'white',
                                fontFamily: 'Inter, Arial, sans-serif',
                                fontSize: '12.32px',
                                fontWeight: '600',
                                textTransform: 'uppercase',
                            }}>
                                <th style={{
                                    padding: '15px 15px 15px 0',
                                    textAlign: 'left',
                                    borderBottom: '1px dotted #dee2e6',
                                }}>
                                    S.N
                                </th>
                                <th style={{ padding: '15px', textAlign: 'left', borderBottom: '1px dotted #dee2e6' }}>BATCH ID</th>
                                <th style={{ padding: '15px', textAlign: 'left', borderBottom: '1px dotted #dee2e6' }}>DATE & TIME</th>
                                <th style={{ padding: '15px', textAlign: 'left', borderBottom: '1px dotted #dee2e6' }}>CATEGORY</th>
                                <th style={{ padding: '15px', textAlign: 'left', borderBottom: '1px dotted #dee2e6' }}>ITEM</th>
                                <th style={{ padding: '15px', textAlign: 'left', borderBottom: '1px dotted #dee2e6' }}>BAL QTY</th>
                                <th style={{ padding: '15px', textAlign: 'left', borderBottom: '1px dotted #dee2e6' }}>BAG NO</th>
                                <th style={{ padding: '15px', textAlign: 'left', borderBottom: '1px dotted #dee2e6' }}>OUTPUT</th>
                                <th style={{ padding: '15px', textAlign: 'left', borderBottom: '1px dotted #dee2e6' }}>ACTIONS</th>
                            </tr>
                        </thead>
                        <tbody className="text-black">
                            {loading ? (
                                <tr>
                                    <td colSpan={9} className="text-center" style={{ padding: '20px 12px', color: "gray" }}>
                                        Loading...
                                    </td>
                                </tr>
                            ) : productions && productions.length > 0 ? (
                                productions.map((item: any, index: number) => (
                                    <tr key={item.id || index} style={{ backgroundColor: 'white' }}>
                                        <td style={{ padding: '20px 12px', borderBottom: '1px dotted #dee2e6' }}>{index + 1}</td>
                                        <td style={{ padding: '20px 12px', borderBottom: '1px dotted #dee2e6' }}>
                                            {item.productionId}
                                        </td>
                                        <td style={{ padding: '20px 12px', fontWeight: '500', borderBottom: '1px dotted #dee2e6' }}>
                                            {new Date(parseInt(item.createdAt)).toLocaleDateString('en-GB', {
                                                day: '2-digit',
                                                month: '2-digit',
                                                year: 'numeric'
                                            })}
                                        </td>
                                        <td style={{ padding: '20px 12px', borderBottom: '1px dotted #dee2e6' }}>
                                            {item?.productionItemDetails?.[0]?.categoryName}
                                        </td>
                                        <td style={{ padding: '20px 12px', borderBottom: '1px dotted #dee2e6' }}>
                                            {item?.productionItemDetails?.[0]?.itemName}
                                        </td>
                                        <td style={{ padding: '20px 12px', borderBottom: '1px dotted #dee2e6' }}>
                                            {parseFloat(item.remainingInputQuantity).toFixed(2)}
                                        </td>
                                        <td style={{ padding: '20px 12px', borderBottom: '1px dotted #dee2e6' }}></td>
                                        {/* <td style={{ padding: '20px 12px', borderBottom: '1px dotted #dee2e6' }}></td> */}
                                        <td style={{ padding: '20px 12px', borderBottom: '1px dotted #dee2e6' }}>
                                            <Link
                                                to={`print-tag/${item.id}`}
                                                state={{ productionData: item }}
                                                style={{
                                                    textDecoration: 'none',
                                                    padding: '6px 12px',
                                                    color: '#495057',
                                                    backgroundColor: '#f8f9fa',
                                                    border: '1px solid #dee2e6',
                                                    borderRadius: '30px',
                                                    fontSize: '13px',
                                                    fontWeight: '400',
                                                    display: 'inline-block'
                                                }}
                                            >
                                                Print Tags
                                            </Link>
                                        </td>
                                        <td style={{ padding: '20px 12px', borderBottom: '1px dotted #dee2e6' }}></td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan={9} className="text-center" style={{ padding: '20px 12px', color: "gray" }}>
                                        No matching records found
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
            </div>
        </KTCard>
    )
}

interface ProductionWrapperProps {
    processName: string
    processId: string
}

const ProductionWrapper: FC<ProductionWrapperProps> = (props) => {
    return <ProductionList {...props} />
}

export { ProductionWrapper }